<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio --->
    <TsLoginPage :service_title="service_title" :service="service" :cluster="cluster" :comp_credito="comp_credito">
      <!-- Slot con info generiche prima del form -->
      <template v-slot:form-header>
        <b-row class="mt-2">
          <b-col>
            <h5>PER INIZIARE:</h5>
            <ul>
              <li>Ricordati che una volta convertito il credito in una fringe app, lo stesso <u>non potrà più essere riportato in piattaforma Welfarebit.</u></li>
              <li>Consulta la <b-link :to="{ 'name' : 'site-documentazione', 'params': { 'group_to_show' : 'fringe-app' } }">Documentazione</b-link> per maggiori informazioni sull'uso dell'app.</li>
            </ul>
          </b-col>
        </b-row>
      </template>
      <!-- Slot con info da porre dopo il form -->
      <template v-slot:form-footer>
        <b-row class="mt-2">
          <b-col>
            <p class="text-danger h5 text-justify">
              Il massimo spendibile in quest'area utilizzando il credito welfare, ammonta a quanto attualmente disponibile per i buoni ( art. 51c3 ) ed è pari a {{credito_buoni}} €.
            </p>
          </b-col>
        </b-row>
      </template>
    </TsLoginPage>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TsLoginPage from '@/components/tantosvago/TsLoginPage'

export default {
  name: 'TsGoWelfare',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Buoni - GOWelfare", link : 'conv-gowelfare' } ],

        // variabili che definiscono il servizio dei buoni GoWelfare con la quale
        // configuriamo la pagina di login.
        service_title: "Buoni - GOWelfare",
        service: "gowelfare.converter",
        cluster: "home",
        comp_credito: "art51c3",

        // Il credito per i buoni da poter spendere per le giftcard
        credito_buoni : this.$store.state.user.user_credito.art51c3
    }
  },
  components: {
    PageTagline,
    TsLoginPage
  }
}
</script>

<style scoped></style>